import { all } from 'redux-saga/effects'

import { editStrategyRootSaga } from '../state/edit-strategy-slice'

export function* rootSaga() {
  yield all([editStrategyRootSaga()])
}
